import Home from './Home';
import HomeQuery from './HomeQuery.graphql';

Home.query = HomeQuery;

export default Home;
